// extracted by mini-css-extract-plugin
export default {"header":"pass_header__yoakC","component":"pass_component__9rBLL"};